export class Category {
  id: string;
  name: string;
  icon_id?: string;
  subcategories?: Category[];
  index?: number;
  menu_id?: string

  constructor(attr?: Partial<Category>) {
    if (attr) {
      Object.assign(this, attr);
    }
  }
}

export function mapCategoryFromServer(categoryFromServer: any): Promise<Category | null> {
  return new Promise((resolve) => {
    if (categoryFromServer) {
      resolve(new Category({id: String(categoryFromServer.id), name: categoryFromServer.name, icon_id: categoryFromServer.icon_id}));
    } else {
      resolve(null);
    }
  });
}

export function mapCategoriesFromServer(categoriesFromServer: any[]): Promise<Category[]> {
  return new Promise((resolve) => {
    if (categoriesFromServer) {
      const categoryMap: { [key: string]: Category } = {};
      const rootCategories: Category[] = [];

      categoriesFromServer.forEach((cat) => {
        categoryMap[cat.id] = new Category({id: String(cat.id), name: cat.name, icon_id: cat.icon_id, index: cat.index, menu_id: cat.menu_id});
      });

      categoriesFromServer.forEach((cat) => {
        if (cat.parent_category_id) {
          const parentCategory = categoryMap[cat.parent_category_id];
          if (parentCategory) {
            if (!parentCategory.subcategories) {
              parentCategory.subcategories = [];
            }
            parentCategory.subcategories.push(categoryMap[cat.id]);
          }
        } else {
          rootCategories.push(categoryMap[cat.id]);
        }
      });

      resolve(rootCategories);
    } else {
      resolve([]);
    }
  });
}

export function mapCategoriesToServer(categories: Category[], parentCategoryId: string | null = null): Promise<any[]> {
  return new Promise((resolve) => {
    let flatCategories: any[] = [];

    categories?.forEach(category => {
      const serverCategory = {
        id: category.id,
        name: category.name,
        icon_id: category.icon_id,
        parent_category_id: parentCategoryId
      };

      flatCategories.push(serverCategory);

      if (category.subcategories && category.subcategories.length > 0) {
        mapCategoriesToServer(category.subcategories, category.id).then(subcategories => {
          flatCategories.push(...subcategories);
        });
      }
    });

    resolve(flatCategories);
  });
}
